export enum IrisButtonTypeAttributeOptions {
  BUTTON = 'button',
  RESET = 'reset',
  SUBMIT = 'submit'
}
